/**
 * Symmetric thematic links shown in the modal Related badges list.
 * Only name inverses, the same named series, or the same activity in two offices.
 * Unlock ladders stay on `autoClaimRules` / `restrictedRules`.
 */
export const RELATED_BADGE_CLUSTERS: readonly (readonly string[])[] = [
  ['snp0', 'cxaa'], // All for One ↔ One for All (give vs receive the 100 SRT)
  ['2j0v', 'b2x1', 'mqpm'], // Flaky Test Martyr / Samaritan / Acolyte
  ['lvrp', 'jw0k'], // Good Darts! ↔ Shoot Well! (office darts)
  ['kmr1', 'tter'], // Key Man Risk ↔ Token Terminator (same drop, AI outage vs tokens)
  ['dz9q', 'zqtm'], // Honorary Viking ↔ Helan Går (same drop, Swedish pair)
  ['bbcp', 'bbtw'], // Daily Duelist ↔ Talos Takedown (Battle Badges wins)
  ['a4jq', 'r2v8'], // Katz Fishhook Survivor ↔ Phish Guard (phishing)
  ['hero', 'itit'], // My Hero! ↔ IT: You’re In (IT tickets / onboarding)
];
